import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const PRINCIPLES = [
  "Build meals around whole and minimally processed foods most of the time.",
  "Prioritise a clear protein source at main meals.",
  "Use vegetables and fruit for volume, fibre, colour and micronutrients.",
  "Choose mostly wholegrain or high-fibre carbohydrate options when practical.",
  "Adjust carbohydrate portions to appetite, training and goals rather than fearing carbs.",
  "Use fats deliberately — olive oil, avocado, nuts and seeds are useful but energy-dense.",
  "Water is the default drink.",
  "Consistency matters more than perfect meals.",
];

export default function EatPrinciples() {
  return (
    <div className="space-y-8" data-testid="eat-principles-page">
      <div>
        <Link to="/app/eat" className="text-xs uppercase tracking-widest text-muted-foreground inline-flex items-center gap-1 hover:text-primary">
          <ChevronLeft size={14} /> Eat
        </Link>
        <div className="label-eyebrow mt-3">Nutrition Principles</div>
        <h1 className="wordmark mt-2 text-4xl md:text-5xl uppercase">Eight Simple Rules.</h1>
        <p className="mt-2 text-muted-foreground max-w-xl">The BA30 eating framework. Learn once, use forever. No macro counting required.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-3">
        {PRINCIPLES.map((p, i) => (
          <div key={p} className="bg-card border border-border rounded-lg p-5" data-testid={`principle-${i}`}>
            <div className="wordmark text-3xl text-primary">{String(i + 1).padStart(2, "0")}</div>
            <p className="mt-2 text-sm leading-relaxed">{p}</p>
          </div>
        ))}
      </div>

      <div className="bg-foreground text-background rounded-lg p-8">
        <div className="label-eyebrow !text-background/70">Disclaimer</div>
        <p className="mt-3 text-sm text-background/80 leading-relaxed max-w-2xl">
          This content is general nutrition education, not personalised dietetic or medical advice.
          If you have a medical condition, are pregnant, have allergies or eating disorder concerns, or need specialised nutrition guidance,
          please consult a qualified healthcare professional. Portion needs vary — the hand + plate method is a starting guide, not a prescription.
          BA30 does not promise weight loss, muscle gain or specific medical outcomes from individual meals.
        </p>
      </div>
    </div>
  );
}
